export default __webpack_public_path__ + "774926d778da664a65ae8391ed55dc12.jpg";